import React from 'react'

import type { TResponsiveProps } from '@hozana/styling/responsive'

import { Cell } from 'elements/layout/Cell'
import { Row, TRowProps } from 'elements/layout/Row'
import { StretchCell } from 'elements/layout/StretchCell'
import { Text } from 'elements/text/Text'

import { TUserAvatarProps, UserAvatar } from './UserAvatar'
import { TUserNameProps, UserName } from './UserName'

const responsiveProps = { maxW: 'max-width' } as const

export type TUserCardProps = TUserNameProps &
  TResponsiveProps<typeof responsiveProps> &
  Pick<TRowProps, 'gutter'> &
  Pick<TUserAvatarProps, 'userId' | 'size'>

export const UserCard: TFCC<TUserCardProps> = ({ userId, size, maxW, children, gutter = '10px', ...otherProps }) => (
  <Row h="100%" nowrap gutter={gutter} w="100%">
    <Cell align="middleCenter">
      <UserAvatar userId={userId} size={size} />
    </Cell>
    <StretchCell align="middleLeft" maxW={maxW} style={{ textAlign: 'left' }}>
      <UserName userId={userId} bold {...otherProps}>
        {children && (
          <>
            <Text vAlign="initial">{children}</Text>
            &nbsp;
          </>
        )}
      </UserName>
    </StretchCell>
  </Row>
)
